import React, { CSSProperties, useEffect, useRef, useState } from 'react'
import { loadTrustpilotScript } from './tpLoader'
interface WidgetProps {
  id: string
  style?: CSSProperties
}

const TrustpilotRating = ({ id, style }: WidgetProps): JSX.Element => {
  const tpRef = useRef(null)
  const [domLoaded, setDomLoaded] = useState(false)

  const loadTrustpilot = async () => {
    await loadTrustpilotScript()
    await window?.Trustpilot?.loadFromElement(tpRef.current, true)
  }

  useEffect(() => {
    loadTrustpilot()
    setDomLoaded(true)
  }, [])

  return (
    <div style={{ height: '30px' }}>
      {domLoaded && (
        <div
          className="trustpilot-widget"
          ref={tpRef} // We need a reference to this element to load the widget in the useEffect.
          style={style}
          id={id}
          data-testid={id}
          data-locale="en-GB"
          data-template-id="5419b637fa0340045cd0c936"
          data-businessunit-id="4c5153c900006400050d7636"
          data-style-height="26px"
          data-style-width="230px"
          data-theme="light"
          data-text-color="#333333"
        ></div>
      )}
    </div>
  )
}

export default TrustpilotRating
